import PageWrapper from 'common/components/PageWrapper'
import { CRUDAction, FeatureKey } from 'common/constants/permission'
import { usePermitToActionFeature } from 'modules/user/api/selector'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { PATH_DASHBOARD } from 'routes/paths'

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined'
import MedicationOutlinedIcon from '@mui/icons-material/MedicationOutlined'
import RestaurantOutlinedIcon from '@mui/icons-material/RestaurantOutlined'
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined'
import { Box, Card, Grid, IconButton, Stack, Typography } from '@mui/material'

const InventorySettingsPage = () => {
  const { t } = useTranslation('warehouse')
  const navigate = useNavigate()
  // ตั้งค่าตัวเลือกอาหาร/เวชภัณฑ์เป็นการแก้ไข (update) การแสดงผล คนที่มีสิทธิ์
  // คลังแค่ "ดู" จึงไม่ควรเห็นการ์ดนี้เลย (ตรงกับ mobile)
  const canManageInventory = usePermitToActionFeature([CRUDAction.Update], FeatureKey.Inventory)

  const LINKS = [
    { name: t('inventory.title'), href: PATH_DASHBOARD.inventory.product },
    { name: t('inventory.settings.title') },
  ]

  const SETTINGS_ITEMS = [
    {
      icon: <HomeOutlinedIcon sx={{ fontSize: 28, color: 'common.white' }} />,
      label: t('warehouse.title'),
      path: PATH_DASHBOARD.inventory.warehouse,
    },
    {
      icon: <ListAltOutlinedIcon sx={{ fontSize: 28, color: 'common.white' }} />,
      label: t('settings.category'),
      path: PATH_DASHBOARD.inventory.category,
    },
    ...(canManageInventory
      ? [
          {
            icon: <SecurityOutlinedIcon sx={{ fontSize: 28, color: 'common.white' }} />,
            label: t('settings.stock_enforcement.title'),
            path: PATH_DASHBOARD.inventory.stockEnforcement,
          },
          {
            icon: <RestaurantOutlinedIcon sx={{ fontSize: 28, color: 'common.white' }} />,
            label: t('settings.display.title_food'),
            path: PATH_DASHBOARD.inventory.displaySettingsFood,
          },
          {
            icon: <MedicationOutlinedIcon sx={{ fontSize: 28, color: 'common.white' }} />,
            label: t('settings.display.title_medicine'),
            path: PATH_DASHBOARD.inventory.displaySettingsMedicine,
          },
        ]
      : []),
  ]

  return (
    <PageWrapper
      title={
        <Stack direction="row" spacing={0.5} alignItems="center">
          <IconButton size="small" onClick={() => navigate(PATH_DASHBOARD.inventory.product)}>
            <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
          </IconButton>
          <Typography variant="h4">{t('inventory.settings.title')}</Typography>
        </Stack>
      }
      titleHead={t('inventory.settings.title')}
      links={LINKS}
    >
      <Grid container spacing={3}>
        {SETTINGS_ITEMS.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.label}>
            <Card
              onClick={() => navigate(item.path)}
              sx={{
                p: 3,
                borderRadius: 3,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0px 2px 8px 0px #00000014',
                '&:hover': { boxShadow: '0px 4px 16px 0px #00000020' },
                transition: 'box-shadow 0.2s ease',
              }}
            >
              <Box
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: 2,
                  bgcolor: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {item.icon}
              </Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, color: 'primary.main', fontSize: 18 }}
              >
                {item.label}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </PageWrapper>
  )
}

export default InventorySettingsPage
